<template>
  <path
    d="M19 3.00018H5C3.9 3.00018 3 3.90018 3 5.00018V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00018C21 3.90018 20.1 3.00018 19 3.00018ZM15 11.0002C15 12.1002 14.1 13.0002 13 13.0002H11V15.0002H14C14.55 15.0002 15 15.4502 15 16.0002C15 16.5502 14.55 17.0002 14 17.0002H10C9.45 17.0002 9 16.5502 9 16.0002V13.0002C9 11.9002 9.9 11.0002 11 11.0002H13V9.00018H10C9.45 9.00018 9 8.55018 9 8.00018C9 7.45018 9.45 7.00018 10 7.00018H13C14.1 7.00018 15 7.90018 15 9.00018V11.0002Z"
  />
</template>
